import Echo from 'laravel-echo';
window.Pusher = require('pusher-js');

/**
 * When a user logs in a new echo object needs to be initted, thus why there is the initEcho
 * in /auth/store/actions. However because we are saving state between sessions sometimes stations
 * would try to connect to a websocket channel without echo being initted yet. Which is why there
 * is some async code that waits for an actual confirmation that echo exists before proceeding.
 */

export const initEcho = (pusherConfiguration, token) => {
  const echoConfiguration = {
    broadcaster: 'pusher',
    wsHost: pusherConfiguration.host || window.sbvrenv.SOCKET_URL,
    key: pusherConfiguration.key,
    disableStats: true,
    encrypted: true,
    authEndpoint: pusherConfiguration.authEndpoint,
    auth: {
      headers: {
        XBroadcaster: pusherConfiguration.broadcaster,
        Authorization: `Bearer ${token}`,
      },
    },
  };
  window.echo = new Echo(echoConfiguration);
};

export const checkEchoService = () => {
  return new Promise(resolve => {
    const interval = setInterval(() => {
      if (window.echo) {
        clearInterval(interval);
        resolve(window.echo);
      }
    }, 500);
  });
};
